var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9083 7.70057V16.4617H6.45121C6.3979 16.4617 6.34477 16.4352 6.31802 16.4084L1.31167 12.0945L6.29139 7.75377C6.31796 7.72721 6.37127 7.70046 6.42458 7.70046L22.9083 7.70065V7.70057ZM23.3875 6.63537H6.45112C6.13162 6.63537 5.83868 6.74181 5.59887 6.95487L0.219701 11.6418C-0.0732337 11.8814 -0.0732337 12.3341 0.219701 12.5739L5.59887 17.2339C5.8385 17.447 6.13142 17.5534 6.45112 17.5534H23.4141C23.7336 17.5534 24 17.287 24 16.9676L23.9998 7.22111C23.9733 6.90161 23.7069 6.63525 23.3874 6.63525L23.3875 6.63537Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab);
export default __webpack_public_path__ + "static/media/tab.a567b674.svg";
export { ForwardRef as ReactComponent };